import clsx from 'clsx';
import React from 'react';

import { useBlueconicContext } from '@contexts/BlueconicContext';
import useEventTracking from '@hooks/useEventTracking';
import { highlight_path } from '@routes';
import { ClickTarget, click } from '@tracking';
import { captureBlueconicClickEvent } from '@utils/blueconic/utils';
import { parameterize } from '@utils/formatting';

interface HighlightProps {
  className?: string;
  customPath?: string;
  highlight: string;
}

const Highlight = ({ className, customPath, highlight = '' }: HighlightProps) => {
  const { trackEvent } = useEventTracking();
  const { variantId } = useBlueconicContext();
  const clickTargetCapture = () => {
    trackEvent(click({ clickTarget: ClickTarget.Highlight, clickText: highlight }));
    if (variantId) {
      captureBlueconicClickEvent(variantId);
    }
  };

  return (
    <a
      href={customPath ?? highlight_path(parameterize(highlight))}
      onClickCapture={clickTargetCapture}
      className={clsx(
        'mb-4 block font-suisse-intl-mono text-overline-md text-primary-magenta',
        className
      )}
      data-type="link"
      data-name="article highlight"
      data-location="feed"
    >
      {highlight}
    </a>
  );
};

export default Highlight;
